import type { ReactNode } from "react";

import { cx } from "../lib/cx";

export interface FieldShellProps {
  id: string;
  label: string;
  required?: boolean;
  error?: string | null;
  hint?: string;
  children: ReactNode;
  className?: string;
}

export function FieldShell({
  id,
  label,
  required,
  error,
  hint,
  children,
  className,
}: FieldShellProps) {
  return (
    <div className={cx("flex flex-col gap-2", className)}>
      <label htmlFor={id} className="text-sm font-semibold text-text">
        {label}
        {required ? <span className="ml-1 text-accent">*</span> : null}
      </label>
      {children}
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-sm text-rose-500">
          {error}
        </p>
      ) : hint ? (
        <p className="text-xs text-muted">{hint}</p>
      ) : null}
    </div>
  );
}

/** Shared look for text-like controls. */
export const controlClass =
  "w-full rounded-control bg-bg px-4 py-3 text-text shadow-clay-pressed outline-none transition-all placeholder:text-muted/70 focus:brightness-[1.02] disabled:opacity-60";
